import { render, staticRenderFns } from "./file-icon.generic.vue?vue&type=template&id=96bf0892&"
import script from "./file-icon.generic.vue?vue&type=script&lang=js&"
export * from "./file-icon.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports